module.exports = __webpack_public_path__ + "videos/afe63bdab13c5751711ae369a43bfd11.mp4";